



























































































import mixins from 'vue-typed-mixins';
import { ReportNode, QuestionData } from '@/utils/ReportUtils';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },
  },

  computed: {
    answer(): any {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },

    visitPercent(): any {
      if (
        this.answer &&
        this.answer.francophonevisit > 0 &&
        this.answer.totalvisit > 0
      ) {
        return (
          Math.round(
            (this.answer.francophonevisit / this.answer.totalvisit) * 100 * 10
          ) / 10
        );
      } else {
        return undefined;
      }
    },

    clientPercent(): any {
      if (
        this.answer &&
        this.answer.francophoneclients > 0 &&
        this.answer.totalclients > 0
      ) {
        return (
          Math.round(
            (this.answer.francophoneclients / this.answer.totalclients) *
              100 *
              10
          ) / 10
        );
      } else {
        return undefined;
      }
    },
  },
  methods: {
    handleChange() {
      this.$emit('dirty');
      if (this.value.data.participation) {
        let completeness = 0;
        if (
          this.answer.totalvisit !== undefined &&
          this.answer.totalvisit?.length > 0
        ) {
          completeness++;
        }
        if (
          this.answer.totalclients !== undefined &&
          this.answer.totalclients?.length > 0
        ) {
          completeness++;
        }
        this.value.data.participation.completeness = completeness / 2;
      }
    },
  },
});
